export default __webpack_public_path__ + "static/media/search.4e283ea0.svg";